// extracted by mini-css-extract-plugin
module.exports = {"group":"ToggleInput_group___WupN","append":"ToggleInput_append__2COYE","normal":"ToggleInput_normal__2SN2r","large":"ToggleInput_large__auVxN"};